import Suppliers from "./Suppliers";
import SupplierSearchMenu from "./SupplierSearchMenu";

const SupplierSearchPage = () => {
    return (
        <>
            <SupplierSearchMenu />
            <Suppliers />
        </>
    );
};

export default SupplierSearchPage;
